import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  fontFamily: 'heading',
  textTransform: 'uppercase',
  borderRadius: 0.5,
});

const sizes = defineStyle({
  sm: {
    fontSize: 13,
    height: 34,
  },
  md: {
    fontSize: 14,
    height: 45,
  },
  lg: {
    fontSize: 20,
    height: 54,
  },
});

// const variants = defineStyle({
//   outlined: {
//     fontFamily: 'heading',
//     // bg: 'blue',
//     // color: 'white',
//     // border: 'none',
//     // _disabled: {
//     //   bg: 'gray.500',
//     //   color: 'white',
//     //   _hover: {
//     //     bg: 'gray.500',
//     //     color: 'white',
//     //   },
//     // },
//   },
// });

export const buttonTheme = defineStyleConfig({
  baseStyle,
  sizes,
  // variants,
});
